import { LAYOUT } from '@/router/constant';
import { AppRouteModule } from '@/router/types';
import { PageEnum } from '@/enums/pageEnum';
import { t } from '@/hooks/web/useI18n';
import { useLocale } from '@/hooks/web/useLocale';

const live: AppRouteModule = {
    path: '/live',
    name: 'Live',
    component: LAYOUT,
    redirect: '/live/index',
    meta: {
        orderNo: 13,
        icon: 'live',
        title: t('routes.index.live.live'),
        // hide: useLocale().hideComponentForCurrentLocale.value,
    },
    children: [
        {
            path: 'index',
            name: PageEnum.LIVE_INDEX,
            component: () => import('@/views/menu/live/index.vue'),
            meta: {
                title: t('routes.index.live.index'),
            },
        },
        {
            path: 'detail',
            name: PageEnum.LIVE_DETAIL,
            component: () => import('@/views/menu/live/detail/index.vue'),
            meta: {
                title: t('routes.index.live.detail'),
            },
        },
    ],
};

export default live;
